module.exports = __webpack_public_path__ + "img/MU.9cfefa35.png";